import { render, staticRenderFns } from "./AppCropperWebCam.vue?vue&type=template&id=48717f3b&"
import script from "./AppCropperWebCam.vue?vue&type=script&lang=js&"
export * from "./AppCropperWebCam.vue?vue&type=script&lang=js&"
import style0 from "./AppCropperWebCam.vue?vue&type=style&index=0&id=48717f3b&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports